/**
 * Type definitions for Export Settings components
 */

/**
 * Value representing "All Periods" in period selection
 */
export const ALL_PERIODS = -1;

/**
 * Configuration for a single export item
 */
export type ExportItemConfig = {
    /** Unique identifier for this export (e.g., "Sales", "Titles") */
    label: string;
    /** Action to perform when export button is clicked. Receives state (period or dates). */
    action: (state: { period?: number; startDate?: Date; endDate?: Date }) => void | boolean | Promise<any>;
    /** Whether this export requires period selection */
    requiresPeriod?: boolean;
    /** Whether this export requires date range selection */
    requiresDateRange?: boolean;
    /** Optional default period value (overrides the global active period) */
    defaultPeriod?: number;
    /** Whether to show "All Periods" option in period selector (default: false) */
    allowAllPeriods?: boolean;
    /**
     * When true, period options include upcoming company periods (isActive=2), not only closed + current.
     * Required e.g. for sales export where users may export a future period range.
     */
    includeFuturePeriods?: boolean;
};

/**
 * Props for the ExportItem component
 */
export type ExportItemProps = {
    /** Configuration for this export item */
    config: ExportItemConfig;
    /** Whether this export is pending/disabled due to async operations */
    isPending: boolean;
    /** Available periods for period selection */
    periods: any[];
    /** Default period to select (typically the active period) */
    defaultPeriod?: number;
};
